"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SyncDirection = exports.ExternalIntegrationStatus = exports.ExternalIntegrationTypes = void 0;
var ExternalIntegrationTypes;
(function (ExternalIntegrationTypes) {
    ExternalIntegrationTypes["WOOCOMMERCE"] = "woocommerce";
    ExternalIntegrationTypes["WOOCOMMERCE_LEGACY"] = "woocommerce_legacy";
    ExternalIntegrationTypes["SHOPIFY"] = "shopify";
    ExternalIntegrationTypes["ZAPIER"] = "zapier";
    ExternalIntegrationTypes["API2CART"] = "api2cart";
    ExternalIntegrationTypes["AMAZON_SELLING_PARTNER"] = "amazon_selling_partner";
    ExternalIntegrationTypes["FAIRE"] = "faire";
    ExternalIntegrationTypes["ANKORSTORE"] = "ankorstore";
    ExternalIntegrationTypes["UNLEASHED"] = "unleashed";
    ExternalIntegrationTypes["OPENCART"] = "opencart";
    ExternalIntegrationTypes["EBAY"] = "ebay";
})(ExternalIntegrationTypes = exports.ExternalIntegrationTypes || (exports.ExternalIntegrationTypes = {}));
var ExternalIntegrationStatus;
(function (ExternalIntegrationStatus) {
    ExternalIntegrationStatus["AUTHORIZED"] = "authorized";
    ExternalIntegrationStatus["REJECTED"] = "rejected";
    ExternalIntegrationStatus["EXPIRED"] = "expired";
    ExternalIntegrationStatus["AWAITING_AUTHORIZATION"] = "awaiting_authorization";
    ExternalIntegrationStatus["DELETED"] = "deleted";
})(ExternalIntegrationStatus = exports.ExternalIntegrationStatus || (exports.ExternalIntegrationStatus = {}));
var SyncDirection;
(function (SyncDirection) {
    SyncDirection["INCOMING"] = "incoming";
    SyncDirection["OUTGOING"] = "outgoing";
    SyncDirection["NONE"] = "none";
})(SyncDirection = exports.SyncDirection || (exports.SyncDirection = {}));
